import React, { Component } from "react";
import { connect } from "react-redux";
import { ReduxState } from "../../types/redux";
import { httpClient } from "../../clients/auth/addTokenToHTTPRequests";
import PageTemplate from "../../pages/PageTemplate";

interface Props {
  user: any;
}

class BillingRedirect extends Component<Props> {
  componentDidMount() {
    this.openStripeBilling();
  }

  openStripeBilling = async () => {
    // Show a loading indicator or message while redirecting
    try {
      const response = await httpClient.instance.post(
        process.env.REACT_APP_BACKEND_URL + "/payments/create-portal-session",
        { customer: this.props.user.stripe_id }
      );
      // Redirect to Stripe billing portal
      window.open(response.data.url, "_blank", "noopener,noreferrer");
      // Go back to previous page after opening Stripe in a new tab
      window.history.back();
    } catch (error) {
      console.error("Error opening Stripe billing portal:", error);
    }
  };

  render() {
    return (
      <PageTemplate
        headerType="magenta"
        sidebarType="options"
        hideItemSearching={true}
      >
        <div className="u-mb--48 u-pt--16">
          <h2 className="u-main-font--header u-mb--32">Billing & Invoices</h2>
          <div className="u-background--white u-p--32 u-border-radius--8 u-box-shadow--standard">
            <p className="u-mb--16">Redirecting to Stripe billing portal...</p>
            <p className="u-mb--24">If the portal doesn't open automatically, click the button below.</p>
            <button 
              className="c-button c-button--magenta"
              onClick={this.openStripeBilling}
            >
              Open Billing Portal
            </button>
          </div>
        </div>
      </PageTemplate>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  user: state.user,
});

export default connect(mapStateToProps)(BillingRedirect);
